import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import Button from '../../../components/common/Button';
import TextField from '../../../components/common/TextField';
import { checkCardNumber, checkCardNumberLive } from '../../../modules/validators';
import { cardNumberSubmit } from '../actions';
import contentStackImageUrls from '../../../../resources/contentStackImageUrls.json';

const { plusCard } = contentStackImageUrls;

export class CaptureCardNumber extends Component {
  constructor() {
    super();
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.state = {
      cardNumber: '',
      validationErrors: [],
      submitDisabled: true
    };
  }

  handleChange(event) {
    const value = event.target.value.toString();

    const errors = checkCardNumberLive(value);
    const submitDisabled = checkCardNumber(value).length !== 0;

    this.setState({
      cardNumber: value,
      validationErrors: (errors.length) ? [errors[0]] : [],
      submitDisabled
    });
  }

  handleSubmit(event) {
    event.preventDefault();

    const { cardNumber } = this.state;
    this.props.submit(cardNumber);
  }

  render() {
    const { submitDisabled, validationErrors } = this.state;

    return (
      <div className="capture-card-number container--fixed">
        <img
          src={plusCard}
          onError={(e) => { e.target.src = '../../../../assets/images/landing/plus-card.png'; }}
          className="capture-card-number__icon"
        />
        <h1 className="capture-card-number__header">Enter Card Number</h1>
        <p className="capture-card-number__text">
          Enter the 16 digit card number that can be found on the front and rear of your PLUS card
        </p>
        <form onSubmit={this.handleSubmit}>
          <TextField
            id="card-number"
            className="capture-card-number__input"
            maxLength={16}
            type="tel"
            onChange={this.handleChange}
            errors={validationErrors}
            hintText="e.g. 0000 0000 0000 0000"
          />
          <Button
            className="capture-card-number__button"
            onClick={this.handleSubmit}
            disabled={submitDisabled}
          >
            Continue
          </Button>
        </form>
      </div>
    );
  }
}

CaptureCardNumber.propTypes = {
  submit: PropTypes.func.isRequired
};

const mapDispatchToProps = {
  submit: cardNumberSubmit
};

export default connect(null, mapDispatchToProps)(CaptureCardNumber);
